import { environment } from '@environments/environment';
import { Rescatable } from '../Rescatable';
import { Faqs } from './Faqs';

export class Questions extends Rescatable {
  static _name = 'Questions';
  static pathRequest = `${Rescatable.pathRequestNet}ayuda/productos_preguntas_usuario`;
  static pathRequestIndex = `${Rescatable.pathRequestNet}ayuda/productos_preguntas_usuario`;
  static pk: keyof Questions = 'id';
  static idFacebookSignedRequest: boolean = true;

  id: number;
  id_producto: number;
  nombre_producto: string;
  pregunta: string;
  fecha_hora_ingreso: Date;
  respuesta: string;
  borrada: number;
  fecha_hora_respuesta: Date;
  evaluacion_cliente: number;
  cabecera_versionada?: string;
  id_responsable_respuesta: number;
  id_net_ayuda_pregunta: number;
  nombre_responsable_respuesta: string;
  id_productos_preguntas_padre: number;
  id_versionado_net_ayuda_pregunta?: number;
  fecha_hora_cierre: string;
  //$product: Product;
  $dataArbol?: Faqs[];
  $padre: Questions[];
  $hijos: Questions;
  $dataEstado?: string;
  id_motivo: number;
  $timeRequest: any;
  constructor(element: Questions) {
    super(element);
  }
}
